module.exports = __webpack_public_path__ + "img/Auditfailed.284f7bfd.png";